import { Review } from '../store/review/types';

export const getAssignmentsForSubmission = (submissionId: number, assignments: Review[]): Review[] => {
  return assignments.filter((r) => r.submission_id == submissionId);
};
